export enum NumberOfFormInstances {
  Last5 = 5,
  Last10 = 10,
  Last20 = 20
}
